/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Title_LeadInputs */

const en_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa's most honored`)
};

const es_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El maestro de golf más reconocido`)
};

const de_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowas meistausgezeichneter`)
};

const zh_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`爱荷华州最受尊敬的`)
};

const ar_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أكثر معلّمي الغولف تكريماً`)
};

const fr_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le professeur de golf`)
};

const vi_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giáo viên golf được vinh danh nhất`)
};

const sw_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mwalimu wa gofu`)
};

const th_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ครูสอนกอล์ฟ`)
};

const bs_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najpriznatiji učitelj golfa`)
};

const ja_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイオワで最も栄誉ある`)
};

const ko_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa에서 가장 많은 상을 받은`)
};

const pt_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O professor de golfe`)
};

const it_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'insegnante di golf`)
};

const sv_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowas mest hedrade`)
};

const nl_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa's meest geëerde`)
};

const da_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowas mest hædrede`)
};

const nb_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowas mest hedrede`)
};

const fi_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowan palkituin`)
};

const pl_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najbardziej utytułowany nauczyciel golfa`)
};

const ru_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Самый заслуженный`)
};

const tr_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa'nın en çok onurlandırılan`)
};

const hi_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa का सबसे सम्मानित`)
};

const id_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guru golf paling terhormat`)
};

const ms_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guru golf paling dihormati`)
};

const cs_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejoceňovanější učitel golfu`)
};

const el_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ο πιο τιμημένος`)
};

const he_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מורה הגולף`)
};

const af_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa se mees vereerde`)
};

const hu_about_title_lead = /** @type {(inputs: About_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa legelismertebb`)
};

/**
* | output |
* | --- |
* | "Iowa's most honored" |
*
* @param {About_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_title_lead = /** @type {((inputs?: About_Title_LeadInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Title_LeadInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_title_lead(inputs)
	if (locale === "de") return de_about_title_lead(inputs)
	if (locale === "zh") return zh_about_title_lead(inputs)
	if (locale === "ar") return ar_about_title_lead(inputs)
	if (locale === "fr") return fr_about_title_lead(inputs)
	if (locale === "vi") return vi_about_title_lead(inputs)
	if (locale === "sw") return sw_about_title_lead(inputs)
	if (locale === "th") return th_about_title_lead(inputs)
	if (locale === "bs") return bs_about_title_lead(inputs)
	if (locale === "ja") return ja_about_title_lead(inputs)
	if (locale === "ko") return ko_about_title_lead(inputs)
	if (locale === "pt") return pt_about_title_lead(inputs)
	if (locale === "it") return it_about_title_lead(inputs)
	if (locale === "sv") return sv_about_title_lead(inputs)
	if (locale === "nl") return nl_about_title_lead(inputs)
	if (locale === "da") return da_about_title_lead(inputs)
	if (locale === "nb") return nb_about_title_lead(inputs)
	if (locale === "fi") return fi_about_title_lead(inputs)
	if (locale === "pl") return pl_about_title_lead(inputs)
	if (locale === "ru") return ru_about_title_lead(inputs)
	if (locale === "tr") return tr_about_title_lead(inputs)
	if (locale === "hi") return hi_about_title_lead(inputs)
	if (locale === "id") return id_about_title_lead(inputs)
	if (locale === "ms") return ms_about_title_lead(inputs)
	if (locale === "cs") return cs_about_title_lead(inputs)
	if (locale === "el") return el_about_title_lead(inputs)
	if (locale === "he") return he_about_title_lead(inputs)
	if (locale === "af") return af_about_title_lead(inputs)
	if (locale === "hu") return hu_about_title_lead(inputs)
	return en_about_title_lead(inputs)
});